<template>
  <div>
    <div
      v-if="!isSearchHeader"
      class="d-flex justify-space-between align-center input-field-container"
      :style="{ minWidth: minWidth ? minWidth : 'unset' }"
      :class="mode"
    >
      <input
        :placeholder="placeholderText"
        type="text"
        id="autocomplete-input"
        :value="searchword"
        @input="handleSearchInput"
      />
      <v-btn
        @click="gotosearch"
        height="inherit"
        flat
        class="d-flex search-btn"
      >
        <svg
          class="search-icon"
          width="22"
          height="22"
          viewBox="0 0 22 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.958 16.9585L20.1663 20.1668"
            stroke="white"
            stroke-width="1.375"
            stroke-linecap="round"
          />
          <path
            d="M6.18717 2.99852C7.46805 2.25756 8.95518 1.8335 10.5413 1.8335C15.3508 1.8335 19.2497 5.73235 19.2497 10.5418C19.2497 15.3513 15.3508 19.2502 10.5413 19.2502C5.73186 19.2502 1.83301 15.3513 1.83301 10.5418C1.83301 8.95567 2.25708 7.46854 2.99803 6.18766"
            stroke="white"
            stroke-width="1.375"
            stroke-linecap="round"
          />
        </svg>
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  emits: ["reloadInfiniteScroll"],
  props: {
    isSearchHeader: {
      type: Boolean,
      default: false,
    },
    minWidth: {
      type: String,
    },
    placeholderText: {
      type: String,
    },
    mode: {
      type: String,
      default: "normal",
    },
  },
  data() {
    return {
      searchword: "",
      debounceTimeout: null,
    };
  },
  mounted() {
    if (this.$route.query.search) this.searchword = this.$route.query.search;
  },
  watch: {
    "$route.query"() {
      if (typeof this.$route.query.search === "undefined") this.searchword = "";
    },
  },
  methods: {
    handleSearchInput(event) {
      // Clear any existing timeout
      if (this.debounceTimeout) {
        clearTimeout(this.debounceTimeout);
      }
      
      // Set the search word immediately for UI feedback
      this.searchword = event.target.value;
      
      // Debounce the actual search
      this.debounceTimeout = setTimeout(() => {
        this.gotosearch();
      }, 500); // 500ms delay
    },
    gotosearch() {
      this.$store.commit("setIsShowDesktopHome", true);
      this.searchword.length > 0
        ? (this.$store.commit("setMenuToClose"),
          this.$store.commit("setMobileNavText", this.$t("BaseSearch.search")))
        : this.$store.commit("setMenuToOpen"); // close menu in mobile when typing in search input

      let query = { ...this.$route.params, ...this.$route.query };
      delete query?.page;
      
      // Only update if search term has changed
      const currentSearch = query.search || '';
      if (this.searchword !== currentSearch) {
        if (this.searchword.length >= 1) {
          query.search = this.searchword;
          if (query.tab) delete query.tab;
        } else {
          delete query.search;
        }
        
        this.$router.replace({ query: query });
        this.$emit("reloadInfiniteScroll");
      }
    },
  },
  beforeUnmount() {
    // Clear any existing timeout when component is unmounted
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout);
    }
  },
};
</script>

<style scoped lang="scss">
input::placeholder {
  font-size: $mediumTextSize;
  font-weight: 300;
  text-align: right;
  color: $placeholderColor;
}

.normal.input-field-container {
  border-radius: 7px;
}
.input-field-container {
  border: 2px solid $primaryColor;
  border-radius: 50px;
  // box-shadow: 0px 3px 6px #00000015;
  max-height: 56px;
  min-width: 365px;
  padding: 10px 22px;
  padding-left: 0px;
}

@media only screen and (max-width: 380px) {
  .input-field-container {
    min-width: 100% !important;
  }
}

#autocomplete-input {
  color: #a4a4a4;
  font-size: $mediumTextSize !important;
  font-weight: 300;
  width: 80%;
}

.search-icon {
  height: 22px;
  width: 22px;
  margin: auto;
}

.normal .search-btn {
  border-radius: 7px;
}
.search-btn {
  background: $primaryColor;
  color: white;
  font-size: $mediumTextSize;
  letter-spacing: 0;
  border-radius: 30px 0px 0px 30px;
  min-width: 10px;
  height: 56px !important;
  padding: 13px;

  span {
    font-size: $mediumTextSize;
    font-weight: 400;
    line-height: 21.33px;
    text-align: center;
  }
}
</style>
